<template>
    <base-modal v-model="modals.camera" footerClasses="text-center" size="xl">

        <video ref="video" autoplay playsinline class="video-feed"></video>
        <canvas ref="canvas" style="display: none;"></canvas>

        <div class="error-message" v-if="error">
            {{ $t('feedbacks.camera-error') }}
        </div>

        <template slot="footer">
            <div v-if="cameraStarted">

                <base-button type="primary" @click="capture">
                    {{ $t('common.save') }}
                </base-button>

                <base-button type="secondary" @click="close">
                    {{ $t('common.cancel') }}
                </base-button>
            </div>
        </template>
    </base-modal>
</template>

<script>
    import ModalsController from '@trax/classes/ModalsController'

    export default {

        data() {
            return {
                modals: new ModalsController(['camera']),

                cameraStarted: false,
                stream: null,           // Flux vidéo
                error: false,
                captureWidth: 1920,
                captureHeight: 1080,
            }
        },

        created() {
            this.modals.init(this, 'modals')
        },

        methods: {

            open() {
                this.modals.open('camera')
                this.startCamera('environment')
            },

            close() {
                this.stopCamera()
                this.modals.close('camera')
            },

            async startCamera(face) {

                this.stopCamera();

                try {
                    this.stream = face === 'user'
                        ? await navigator.mediaDevices.getUserMedia({ video: { facingMode: face, width: { ideal: 1920 }, height: { ideal: 1080 }}})
                        : await navigator.mediaDevices.getUserMedia({ video: { exact: face, width: { ideal: 1920 }, height: { ideal: 1080 }}})
                   
                    this.error = false

                } catch (err) {                   
                    this.error = true
                    return
                }

                this.cameraStarted = true
                this.$refs.video.srcObject = this.stream;
            },

            stopCamera() {

                if (this.cameraStarted) {
                    this.stream.getTracks().forEach(track => track.stop());

                    // this.$refs.video.srcObject && this.$refs.video.srcObject.getTracks().map(t => t.stop());
                    this.cameraStarted = false
                }
            },

            capture() {
                const video = this.$refs.video;
                const canvas = this.$refs.canvas;
                const context = canvas.getContext("2d");

                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;
                context.drawImage(video, 0, 0, canvas.width, canvas.height);

                const url = canvas.toDataURL("image/png");

                canvas.toBlob((blob) => {

                    const file = new File([blob], "image.png", { type: "image/png" });

                    // File input.
                    const dataTransfer = new DataTransfer();
                    dataTransfer.items.add(file);

                    this.$emit('addedfile', { file, url, from: 'camera' })

                    this.close()

                }, "image/png", 0.95);
            },

            reset() {
            },
        },

        beforeDestroy() {
            if (this.stream) {
                this.stream.getTracks().forEach(track => track.stop());
            }
        }
    }
</script>

<style scoped>

    .video-feed {
        width: 100%;
    }
    .error-message {
        text-align: center;
        position: absolute;
        top: 85px;
        left: 20px;
        right: 20px;
    }

</style>
